import { GlobalNotificationTypes } from '../../enums/GlobalNotificationTypes';

export const DEFAULT_AUTOHIDE_DELAY = 3000;

export enum NotificationPosition {
  Top = 'Top',
  Left = 'Left',
  Right = 'Right'
}

export interface GlobalNotificationButton {
  text?: string;
  onClick?: () => any;
}

export interface GlobalNotification {
  id?: string;
  type: GlobalNotificationTypes;
  message: string | JSX.Element;
  title?: string;
  autoHide?: boolean;
  delay?: number;
  postition?: NotificationPosition;
  closeButton?: boolean;
  buttons?: {
    confirm?: GlobalNotificationButton;
    cancel?: GlobalNotificationButton;
  };
}

export interface GlobalNotificationsState {
  globalNotifications: GlobalNotification[];
}
